
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 320 320"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 96h256v42.667H0zM0 10.667h256v42.667H0zM0 181.333h170.667V224H0zM213.333 181.333v128l106.667-64z"}})])
          )
        }
      }
    